const extractEmailParts = (email = ''): { email: string; emailDomain: string } | undefined => ({
  email: email.split('@')[0],
  emailDomain: `@${email.split('@')[1]}`,
});

export default extractEmailParts;
